import React from "react";
import PropTypes from "prop-types";
import { Accordion, AccordionTab } from "primereact/accordion";
import { OverlayPanel } from "primereact/overlaypanel";
import { getName } from "country-list";

import SearchBar from "../searchBar/index";
import CustomeButton from "../Button/index";
import CustomCheckBox from "../CheckBox/index";

import "./style.scss";

function UserAccessDropDown({
  refPanel,
  data,
  isLoading,
  searchEntity,
  handleClose,
  handlSelectedService,
  selectedProcess,
  handleSelection,
  handlTogglePayrollPlus,
}) {
  return (
    <OverlayPanel ref={refPanel} className="user-access-overpanel">
      <div className="formgrid">
        <div className="col-12 bg-section drop-section-1">
          <SearchBar
            placeholder="Search entities by name"
            onChange={(e) => searchEntity(e.target.value)}
          />
        </div>

        <div className="col-12 mb-2 user-access-panel">
          {data?.length > 0 ? (
            <Accordion>
              {data?.map((item) => (
                <AccordionTab
                  key={item.id}
                  header={
                    <p className="p-0 m-0">{`${item.name} (${getName(item?.country)})`}</p>
                  }
                >
                  <Accordion>
                    {item?.services?.map((x) => {
                      const header = <p className="p-0 m-0">{x.name}</p>;

                      if (x.name === "Payroll +") {
                        const templateIds = (x?.process_templates || []).map(
                          (template) => template.id,
                        );
                        const entitySel = (selectedProcess || []).find(
                          (process) => process.entity_id === item.id,
                        );

                        const selectedIds = new Set(
                          entitySel?.process_template || [],
                        );
                        const allSelected =
                          templateIds.length > 0 &&
                          templateIds.every((id) => selectedIds.has(id));
                        const someSelected =
                          templateIds.length > 0 &&
                          templateIds.some((id) => selectedIds.has(id)) &&
                          !allSelected;

                        return (
                          <AccordionTab key={x.id} header={header}>
                            <div className="p-field-checkbox pt-2 pb-2">
                              <CustomCheckBox
                                inputId={`checkbox-payroll-${item.id}-${x.id}`}
                                checked={!!allSelected}
                                onChange={(e) =>
                                  handlTogglePayrollPlus(
                                    e.target.checked,
                                    item?.id,
                                    x?.id,
                                    templateIds,
                                  )
                                }
                              />
                              <label
                                className="ml-2"
                                htmlFor={`checkbox-payroll-${item.id}-${x.id}`}
                              >
                                Payroll + (Payslip Integration)
                              </label>
                            </div>
                          </AccordionTab>
                        );
                      }

                      return (
                        <AccordionTab
                          key={x.id}
                          header={<p className="p-0 m-0">{x.name}</p>}
                        >
                          {x?.process_templates?.map((proces) => {
                            const isChecked = selectedProcess?.some(
                              (checkedItem) =>
                                checkedItem?.entity_id === item.id &&
                                checkedItem?.process_template.includes(
                                  proces?.id,
                                ),
                            );
                            return (
                              <div
                                key={proces?.id}
                                className="p-field-checkbox pt-2 pb-2"
                              >
                                <CustomCheckBox
                                  inputId={`checkbox-${proces?.id}`}
                                  checked={isChecked || false}
                                  onChange={(e) =>
                                    handlSelectedService(
                                      e.target.checked,
                                      item?.id,
                                      x?.id,
                                      proces?.id,
                                    )
                                  }
                                />
                                <label
                                  className="ml-2"
                                  htmlFor={`checkbox-${proces?.id}`}
                                >
                                  {proces?.name}
                                </label>
                              </div>
                            );
                          })}
                        </AccordionTab>
                      );
                    })}
                  </Accordion>
                </AccordionTab>
              ))}
            </Accordion>
          ) : (
            <p>No items found</p>
          )}
        </div>

        <div className="col-12 bg-section drop-section-3">
          <div className="flex justify-content-end mt-3">
            <CustomeButton
              label="Cancel"
              variant="outlined"
              className="mr-2"
              onClick={handleClose}
            />
            <CustomeButton
              label={!isLoading && "Add Selection"}
              variant="contained"
              className="access-btn"
              onClick={handleSelection}
              disabled={isLoading || !selectedProcess?.length > 0}
              loading={isLoading}
            />
          </div>
        </div>
      </div>
    </OverlayPanel>
  );
}

UserAccessDropDown.propTypes = {
  refPanel: PropTypes.ref,
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  searchEntity: PropTypes.func,
  handleClose: PropTypes.func,
  handlSelectedService: PropTypes.func,
  selectedProcess: PropTypes.array,
  handleSelection: PropTypes.func,
};
export default UserAccessDropDown;
